import { Button, Group } from '@mantine/core';
import { modals } from '@mantine/modals';
import { IconPlus } from '@tabler/icons-react';
import { i18nKeys, useTranslation } from 'locales';
import { isEmpty } from 'remeda';
import type { TemplateV2 } from 'shared/hooks/use-load-template-v2';
import { AddChannelModal } from './AddChannelModal';
import { channelsForStepType } from './channels';

type AddChannelButtonProps = {
  template: TemplateV2;
};

export const AddChannelButton = ({ template }: AddChannelButtonProps) => {
  const { t } = useTranslation();

  const addableChannels = channelsForStepType(template.stepType).filter(({ key }) =>
    isEmpty(template.bodies[key]),
  );

  if (isEmpty(addableChannels)) return null;

  const openAddChannelModal = () =>
    modals.open({
      title: t(i18nKeys.TEMPLATE.ADD_CHANNEL),
      size: 'lg',
      children: (
        <AddChannelModal
          templateId={template.id}
          channels={addableChannels}
          onClose={modals.closeAll}
        />
      ),
    });

  return (
    <Group align="center" pl="xs">
      <Button
        variant="subtle"
        size="xs"
        leftSection={<IconPlus size={16} stroke={1.5} />}
        onClick={openAddChannelModal}
      >
        {t(i18nKeys.TEMPLATE.ADD_CHANNEL)}
      </Button>
    </Group>
  );
};
